// Spinner mínimo (puro CSS, sin deps). Usar para loading states.
//
// `motion-essential`: la regla global de movimiento reducido (tokens.css)
// apaga las animaciones, pero un indicador de carga quieto parece una
// pantalla colgada; con esta clase sigue girando, más despacio.

import { cn } from '../../lib/utils';

export function Spinner({ className }: { className?: string }) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      className={cn(
        'inline-block size-4 animate-spin rounded-full border-2 border-border border-t-accent motion-essential',
        className,
      )}
    />
  );
}
